import { render, staticRenderFns } from "./AssignOwner.vue?vue&type=template&id=3afcb688&scoped=true"
import script from "./AssignOwner.vue?vue&type=script&lang=js"
export * from "./AssignOwner.vue?vue&type=script&lang=js"
import style0 from "./AssignOwner.vue?vue&type=style&index=0&id=3afcb688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afcb688",
  null
  
)

export default component.exports